import { DocumentStatus } from 'src/app/modules/referrals/interfaces/referrals.model';
import { convertRadioToBoolean } from 'src/app/shared/functions/convert-radio-to-boolean';
import { IReferenceData } from 'src/app/shared/interfaces/form/reference-data.model';

export class IepSubmitEligibilityRequest {
    iepFormSK: string;
    disability: number | IReferenceData;
    isLocked: boolean;
    isSubmit: boolean;
    lackOutstructReading: boolean;
    lackInstructMath: boolean;
    limitedEnglishProf: boolean;
    disabilityClass: boolean | string;
    otherImpairment: number | IReferenceData;
    otherImpairementDesc: string;
    specialEdServ: boolean;
    medicalCondition: boolean;
    physicalLimit: boolean;
    learning: boolean;
    behavior: boolean;
    participation: boolean;
    reqMedicalCare: boolean;
    reqHealthCare: boolean;
    lastModuser: string;
    iepType: string | IReferenceData;
    iepMeetingType: string | IReferenceData | number;
    referralSK: string;
    studentSK: string;
    iepMeetingDate: string;
    projectedAnnRevDate: Date;
    projectedNxtManThreeYrRevalDate: Date;
    iepAmendment: boolean;
    reconveneIEPMeeting: boolean;
    requiresSpecEd: boolean | string;
    meetsOtherDef: boolean | string;
    typeOfMeeting: number;
    actionType: number;
    isAnnual: boolean;
    referenceIEPFormsk: string;
    caseStage: number;
    constructor(eligibilityData: IepSubmitEligibilityRequest) {
        this.iepFormSK = eligibilityData.iepFormSK;
        this.isLocked = eligibilityData.isLocked;
        this.isSubmit = eligibilityData.isSubmit;
        this.actionType = this.isSubmit ? DocumentStatus.Submit : DocumentStatus.SaveForLater
        this.disability = (eligibilityData.disability as IReferenceData)?.id as number;
        this.lackOutstructReading = eligibilityData.lackOutstructReading ?? false;
        this.lackInstructMath = eligibilityData.lackInstructMath ?? false;
        this.limitedEnglishProf = eligibilityData.limitedEnglishProf ?? false;
        this.disabilityClass = eligibilityData.disabilityClass ? convertRadioToBoolean(eligibilityData.disabilityClass as string) : undefined;
        this.otherImpairment = (eligibilityData.otherImpairment as IReferenceData)?.id as number;
        this.requiresSpecEd = eligibilityData.requiresSpecEd ? convertRadioToBoolean(eligibilityData.requiresSpecEd as string) : undefined;
        this.otherImpairementDesc = eligibilityData.otherImpairementDesc;
        this.specialEdServ = eligibilityData.specialEdServ;
        this.medicalCondition = eligibilityData.medicalCondition;
        this.physicalLimit = eligibilityData.physicalLimit;
        this.learning = eligibilityData.learning;
        this.behavior = eligibilityData.behavior;
        this.participation = eligibilityData.participation;
        this.reqMedicalCare = eligibilityData.reqMedicalCare;
        this.reqHealthCare = eligibilityData.reqHealthCare;
        this.lastModuser = eligibilityData.lastModuser;
        this.iepType = (eligibilityData.iepType as IReferenceData)?.id as string;
        this.iepMeetingType = (eligibilityData.iepMeetingType as IReferenceData)?.id as string;
        //required
        this.referralSK = eligibilityData.referralSK;
        //optional
        this.iepMeetingDate = eligibilityData.iepMeetingDate;
        this.projectedAnnRevDate = eligibilityData.projectedAnnRevDate;
        this.projectedNxtManThreeYrRevalDate = eligibilityData.projectedNxtManThreeYrRevalDate;
        this.iepAmendment = eligibilityData.iepAmendment;
        this.reconveneIEPMeeting = eligibilityData.reconveneIEPMeeting;
        this.meetsOtherDef = eligibilityData.meetsOtherDef !== undefined ? convertRadioToBoolean(eligibilityData.meetsOtherDef as string) : eligibilityData.meetsOtherDef;
        this.typeOfMeeting = (eligibilityData?.iepMeetingType as IReferenceData)?.id as number;
        this.isAnnual = eligibilityData?.isAnnual;
        this.referenceIEPFormsk = eligibilityData?.referenceIEPFormsk;
        this.studentSK = eligibilityData?.studentSK;
    }

    get id(): string {
        return this.iepFormSK
    }


}